import translationsData from '../translations.json';
import { TranslationData, Language } from '../types';
import { replaceDatePlaceholders } from '../utils/formatDate';
import { APP_CONFIG } from '../config/settings';

export function useTranslation() {
  const translations = translationsData as TranslationData;

  // Translation function that takes a key and language
  const t = (key: string, lang?: Language): string => {
    const language = lang || APP_CONFIG.DEFAULT_LANGUAGE;
    const keys = key.split('.');
    let value: any = translations.ui[language];

    for (const k of keys) {
      value = value?.[k];
    }

    const text = value || key;
    return typeof text === 'string'
      ? replaceDatePlaceholders(text, language)
      : text;
  };

  return {
    translations,
    t,
  };
}
